<template>
    <b-row no-gutters>
        <b-col cols="1">
            <font-awesome-icon v-show="feature.editState" :icon="['fas', 'pen']" fixed-width />
        </b-col>
        <b-col cols="1" class='text-centered'>
            <b-link @click="$emit('fly-to-feature', feature)">
                <font-awesome-icon :icon="['fas', getRaceIcon()]" :color="linkedFeature.color" fixed-width />
            </b-link>
        </b-col>
        <b-col cols="10">
            <b-link 
                v-b-modal.modal-1
                :class="{ 'font-weight-bold': feature.editState }"
                @click="$emit('feature-clicked', feature)"
                @mouseenter="$emit('toggle-ant-race', feature, true)"
                @mouseleave="$emit('toggle-ant-race', feature, false)"
                >
                {{ feature.name }} ({{ feature.start_city }} / {{ feature.end_city }})
            </b-link>
        </b-col>
    </b-row>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    name: 'RaceFeature',
    props: {
        linkedFeature : Object
    },
    components: {
        FontAwesomeIcon
    },
    data: function () {
        return {
            feature : this.linkedFeature
        }
    },
    methods: {
        getRaceIcon() {
            let discipline = this.$parent.$parent.$parent.disciplines.find(d => d.id == this.feature.discipline);
            if (discipline) {
                return discipline.icon;
            } else {
                return 'route';
            }
        }
    }
}
</script>


<style scoped>

</style>